const ro = {
    nav: {
      home: "Acasă",
      browse: "Explorează Nunți",
      dashboard: "Panou",
      messages: "Mesaje",
      profile: "Profil",
      login: "Autentificare",
      register: "Înregistrare",
      logout: "Deconectare",
      admin: "Admin",
      faq: "FAQ",
      about: "Despre noi",
      contact: "Contact",
      pricing: "Prețuri",
      howItWorks: "Cum funcționează",
    },
    auth: {
      login: {
        title: "Bine ai revenit",
        email: "Email",
        password: "Parolă",
        button: "Autentificare",
        noAccount: "Nu ai cont?",
        register: "Înregistrează-te acum",
      },
      register: {
        title: "Creează cont",
        name: "Nume complet",
        email: "Email",
        password: "Parolă",
        role: "Vreau să...",
        roleHost: "Organizez o nuntă",
        roleGuest: "Particip la nunți",
        terms: "Accept termenii și politica de confidențialitate",
        button: "Înregistrare",
        hasAccount: "Ai deja cont?",
        login: "Autentifică-te",
      },
    },
  review: {
    title: "Write a Review",
    description: "Share your experience with",
    ratingLabel: "How would you rate your experience?",
    rating1: "Poor",
    rating2: "Fair",
    rating3: "Good",
    rating4: "Very Good",
    rating5: "Excellent",
    commentLabel: "Your Review",
    optional: "optional",
    commentPlaceholder: "Tell others about your experience...",
    for: "Review for",
    submit: "Submit Review",
    success: "Review submitted successfully!",
    error: "Failed to submit review",
    selectRating: "Please select a rating",
    noReviews: "No reviews yet",
    received: "Reviews Received",
    averageRating: "Average Rating",
    writeReview: "Write Review",
    reviewed: "Reviewed",
    completedWedding: "This wedding has been completed. You can now write a review.",
  },

    common: {
      loading: "Se încarcă...",
      error: "A apărut o eroare",
      success: "Succes",
      save: "Salvează",
      cancel: "Anulează",
      delete: "Șterge",
      edit: "Editează",
      back: "Înapoi",
      next: "Următorul",
      language: "Limbă",
      currency: "Monedă",
      search: "Căutare",
      filter: "Filtrare",
      all: "Toate",
      none: "Nimic",
      yes: "Da",
      no: "Nu",
    },
    footer: {
      about: "Despre",
      privacy: "Confidențialitate",
      terms: "Termeni",
      contact: "Contact",
      copyright: "© 2024 WEDVAYA. Toate drepturile rezervate.",
    },
  };

export default ro;
